// src/MainLayout.tsx
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import LeftBar from "./components/LeftBar";
import Header from "./components/Header";
import UserLocationReporter from "./components/UserLocationReporter";

type MainLayoutProps = {
  children: React.ReactNode;
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [marginLeft, setMarginLeft] = useState("250px");
  const location = useLocation();

  // Telas que NÃO usam layout completo
  const hideFullLayout =
    location.pathname.startsWith("/rastreamento/entrar") ||
    location.pathname.startsWith("/apidoc") ||
    location.pathname.startsWith("/entrar") ||
    location.pathname.startsWith("/cadastro") ||
    location.pathname.startsWith("/redefinir-senha") ||
    location.pathname.startsWith("/sessao-encerrada");

  const isMapView =
    location.pathname === "/coordenacao/colaboradores/visualizar-mapa";

  // Esconder apenas o Header em /menu/config
  const hideHeader = hideFullLayout || location.pathname === "/menu/config";

  useEffect(() => {
    const updateMargin = () => {
      if (hideFullLayout) {
        setMarginLeft("0px");
      } else {
        setMarginLeft(window.innerWidth < 1000 ? "10px" : "250px");
      }
    };

    updateMargin();
    window.addEventListener("resize", updateMargin);
    return () => window.removeEventListener("resize", updateMargin);
  }, [hideFullLayout]);

  return (
    <div style={{ display: "flex" }}>
      {/* Heartbeat de localização – fica ativo em todas as páginas logadas */}
      <UserLocationReporter />

      {!hideFullLayout && <LeftBar />}
      {!hideHeader && <Header />}

      <div
        style={{
          flex: 1,
          marginLeft: hideFullLayout || isMapView ? "0px" : marginLeft,
          padding: hideFullLayout || isMapView ? "0px" : "20px",
          transition: "margin-left 0.3s ease",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default MainLayout;
